import React from "react";
// global context (this.props.data)
import { WithContext } from "store/DataProvider";
// react-bootstrap components
import {
  Container,
  Row,
  Col,
  Alert,
  Button,
  Modal,
  InputGroup,
  FormControl,
} from "react-bootstrap";
// custom component
import Accordions from "stocks/accordions/component";
import FloatingSaveButton from "buttons/FloatingSaveButton";
// react-icons
import { MdDelete, MdOutlineSplitscreen } from "react-icons/md";
// momentjs
import moment from "moment";

class createMouvementStock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteModal: {
        show: false,
      },
      splitModal: {
        show: false,
      },
      splitQuantite: "",
    };
    const id =
      this.props.history.location.state && this.props.history.location.state.id;
    if (id) {
      this.state.mouvement = { ...this.props.history.location.state };
    } else {
      this.state.mouvement = {
        // id: 1,
        date: moment().format("YYYY-MM-DD"),
        typeDeMouvementId: 1,
        produits: [],
        fournisseur: "",
        numeroFacture: "",
      };
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSplitQuantityChange = this.handleSplitQuantityChange.bind(this);
    this.handleReactSelectChange = this.handleReactSelectChange.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.updateReactSelectItem = this.updateReactSelectItem.bind(this);
    this.validate = this.validate.bind(this);
    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
    this.splitByProduct = this.splitByProduct.bind(this);
    this.splitByQuantity = this.splitByQuantity.bind(this);
  }

  isUpdate() {
    return (
      this.props.history.location.state && this.props.history.location.state.id
    );
  }

  handleChange(e) {
    const target = e.target;
    const type = target.type;
    let value = target.value;
    const name = target.name;
    // pour pouvoir accéder au nativeEvent
    if (type === "select-one") e.persist();

    this.setState((state) => {
      let newValue = value;
      if (type === "select-one") {
        if (value) {
          const nativeTarget = e.nativeEvent.target;
          const index = nativeTarget.selectedIndex;
          const label = nativeTarget[index].text;
          // ajouter l'id et le label de l'option sélectionnée
          newValue = [{ id: Number(value), label: label }];
        } else {
          newValue = [];
        }
      } else if (type === "number" && value !== "") {
        // tronquer au nombre de décimales souhaité
        const decimals = target.getAttribute("decimals");
        newValue = +Number(target.value).toFixed(decimals);
      } else if (type === "radio") {
        newValue = Number(value);
      }
      state.mouvement[name] = newValue;
      return state;
    });
  }

  handleSplitQuantityChange(e) {
    const target = e.target;
    let value = e.target.value;
    this.setState((state) => {
      let newValue = value;
      const decimals = target.getAttribute("decimals");
      newValue = +Number(target.value).toFixed(decimals);
      state.splitQuantite = newValue;
      return state;
    });
  }

  handleReactSelectChange(name, options) {
    this.setState((state) => {
      state.mouvement[name] = options;
      return state;
    });
  }

  updateItem(e) {
    e.persist();
    const produitId = Number(e.target.getAttribute("data-id"));
    let propName = e.target.name;
    if (propName.includes("typeSemence")) {
      propName = "typeSemence";
    }
    let value = e.target.value;
    if (e.target.type === "radio") {
      value = Number(value);
    }
    this.setState((state) => {
      const produitIndex = this.state.mouvement.produits.findIndex(
        (produit) => produit.id === produitId
      );
      if (produitIndex !== -1) {
        state.mouvement.produits[produitIndex][propName] = value;
      }
      return state;
    });
  }

  updateReactSelectItem(produitId, option) {
    this.setState((state) => {
      const produitIndex = this.state.mouvement.produits.findIndex(
        (produit) => produit.id === produitId
      );
      if (produitIndex !== -1) {
        state.mouvement.produits[produitIndex].traitementSemence = [option];
      }
      return state;
    });
  }

  validate() {
    const mouvement = { ...this.state.mouvement };
    // prix unitaire facultatif = 0 si non renseigné
    mouvement.produits.forEach((p) => {
      if (!p.prixUnitaire) {
        p.prixUnitaire = "0";
      }
    });
    if (this.isValid(mouvement)) {
      this.save();
    }
  }

  isValid(mouvement) {
    let isValid = true;
    mouvement.produits.forEach((produit) => {
      if (!produit.quantite) {
        isValid = false;
        this.showError(`Produit ${produit.label} : quantité non renseignée.`);
      }
    });
    return isValid;
  }

  showError(message) {
    this.props.data.showNotification({
      type: "danger",
      title: message,
    });
  }

  async save() {
    let mouvement = { ...this.state.mouvement };
    let requestName;
    if (mouvement.id) {
      requestName = "update";
    } else {
      requestName = "create";
    }
    const response = await this.props.data.sendRequest(requestName, {
      listName: "mouvementsStocks",
      item: mouvement,
    });
    if (response) {
      this.goToList();
    }
  }

  showModal(modal) {
    this.setState({ [modal]: { show: true } });
  }

  hideModal(modal) {
    this.setState({ [modal]: { show: false } });
  }

  async delete() {
    const { id } = this.props.history.location.state;
    const response = await this.props.data.sendRequest("delete", {
      itemId: id,
      listName: "mouvementsStocks",
    });
    if (response.success) {
      this.goToList();
    }
  }

  async splitByProduct() {
    const { id } = this.props.history.location.state;
    const response = await this.props.data.sendRequest(
      "decomposerStockParProduits",
      {
        itemId: id,
      }
    );
    if (response.success) {
      this.goToList();
    }
  }

  async splitByQuantity() {
    const { id } = this.props.history.location.state;
    const response = await this.props.data.sendRequest(
      "decomposerStockParQuantite",
      {
        itemId: id,
        quantite: this.state.splitQuantite,
      }
    );
    if (response.success) {
      this.goToList();
    }
  }

  goToList() {
    this.props.history.goBack();
  }

  render() {
    const isUpdate = this.isUpdate();
    const { deleteModal, splitModal, splitQuantite } = this.state;
    const { typeDeMouvementId, produits } = this.state.mouvement;
    return (
      <Container>
        <Row>
          <Alert
            variant={isUpdate ? "warning" : "success"}
            className="text-center w-100 mb-0"
          >
            <Alert.Heading>
              {isUpdate
                ? "Modifier un mouvement de stock"
                : "Créer un mouvement de stock"}
            </Alert.Heading>
          </Alert>
        </Row>
        <Row>
          <Accordions
            isUpdate={isUpdate}
            mouvement={this.state.mouvement}
            handleChange={this.handleChange}
            handleReactSelectChange={this.handleReactSelectChange}
            updateItem={this.updateItem}
            updateReactSelectItem={this.updateReactSelectItem}
            history={this.props.history}
          />
        </Row>
        <Row className="mt-3 mb-3">
          <Col className="d-flex justify-content-end">
            {isUpdate && (
              <Button
                variant="danger"
                onClick={() => this.showModal("deleteModal")}
              >
                Supprimer le mouvement
                <MdDelete size={25} className="ml-2" />
              </Button>
            )}
            {/* {isUpdate && typeDeMouvementId === 4 && (
              <Button
                variant="info"
                onClick={() => this.showModal("splitModal")}
                className="ml-2"
              >
                Décomposer le mouvement
                <MdOutlineSplitscreen size={25} className="ml-2" />
              </Button>
            )} */}
            {/* <Button variant="warning" onClick={this.validate} className="ml-2">
              Enregistrer
              <MdEdit size={25} className="ml-2" />
            </Button> */}
          </Col>
        </Row>
        <FloatingSaveButton title="Enregistrer" onClickFn={this.validate} />
        <Modal
          centered
          show={deleteModal.show}
          onHide={() => this.hideModal("deleteModal")}
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Êtes-vous certain de vouloir supprimer ce mouvement de stock ?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.hideModal("deleteModal")}
            >
              Annuler
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                this.delete();
                this.hideModal("deleteModal");
              }}
            >
              Supprimer
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          centered
          show={splitModal.show}
          onHide={() => this.hideModal("splitModal")}
        >
          <Modal.Header closeButton>
            <Modal.Title>Décomposer le mouvement</Modal.Title>
          </Modal.Header>
          {produits.length > 1 && (
            <>
              <Modal.Body>
                <strong>Par produit :</strong>
                <br />
                <br />
                Pour chaque produit, un nouveau mouvement sera créé.
                <br />
                Les informations de chaque produit seront conservées à
                l'identique (quantités, prix unitaires, numéros de lots).
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => this.hideModal("splitModal")}
                >
                  Annuler
                </Button>
                <Button
                  variant="success"
                  onClick={() => {
                    this.splitByProduct();
                    this.hideModal("splitModal");
                  }}
                >
                  Décomposer le mouvement
                </Button>
              </Modal.Footer>
            </>
          )}
          {produits.length === 1 && (
            <>
              <Modal.Body>
                <strong>Par quantité de produit :</strong>
                <br />
                <br />
                Vous renseignez la quantité à décomposer.
                <br />
                Deux nouveaux mouvements seront créés : un avec la quantité
                renseignée, et l'autre avec la quantité restante.
                <br />
                <br />
                <strong>{produits[0].label}</strong> - Quantité :{" "}
                {produits[0].quantite} {produits[0].unit}
                <br />
                <br />
                <InputGroup size="sm" className="mb-2">
                  <InputGroup.Prepend>
                    <InputGroup.Text>Quantité à décomposer</InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControl
                    name="splitQuantite"
                    type="number"
                    step={produits[0].step ?? 1}
                    min={0}
                    value={splitQuantite}
                    onChange={this.handleSplitQuantityChange}
                  />
                  {produits[0].unit && (
                    <InputGroup.Append>
                      <InputGroup.Text>{produits[0].unit}</InputGroup.Text>
                    </InputGroup.Append>
                  )}
                </InputGroup>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => this.hideModal("splitModal")}
                >
                  Annuler
                </Button>
                <Button
                  variant="success"
                  onClick={() => {
                    this.splitByQuantity();
                    this.hideModal("splitModal");
                  }}
                  disabled={!this.state.splitQuantite}
                >
                  Décomposer le mouvement
                </Button>
              </Modal.Footer>
            </>
          )}
        </Modal>
      </Container>
    );
  }
}

export default WithContext(createMouvementStock);
